module.exports = __webpack_public_path__ + "img/good7.0f5fbd85.png";